<template>  
  <div class="container-fluid mt-3">
    <div class="row">

      <div class="col-12 col-xl-8 border-xl-right vh-100 order-2 order-xl-1" style="max-height: 600px">
        <div class="card border-0">
          <div class="card-header bg-transparent"><h3 class="text-muted">Your Builds</h3></div>

          <slot v-if="userBuildComp == 0">
            <div v-if="userBuildList.length < 1" class="card-body mt-4">
              <div class="col-12 d-flex justify-content-center align-items-center">
                <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style=""/>
                <span class="ml-3 h4" style="color:#0E1698">Loading Builds...</span>
              </div>
            </div>
          </slot>

          <slot v-if="userBuildComp == 1">
            <div v-if="userBuildList.length == 0" class="card-body mt-4">
              <div class="col-12 text-center">
                <h3 class="text-muted">No Existing Builds were Found.</h3>
              </div>
            </div>
            <div v-if="userBuildList.length > 0" class="card-body mb-4">

              <div class="d-none d-lg-block">
                <v-client-table :data="userBuildList" :columns="tableColumns" :options="tableOptions">
                  <div slot="slot1" slot-scope="props">
                    <a href="#" class="" @click="viewBuild(props.row.id)"><i class="fa fa-search" aria-hidden="true"></i></a>
                  </div>
                  <div slot="slot2" slot-scope="props">
                    {{ props.row.tot_price | currency }}
                  </div>
                  <div slot="slot3" slot-scope="props">
                    {{ props.row.created_at | moment("MM-DD-YYYY") }}
                  </div>
                </v-client-table>
              </div>

              <div class="d-block d-lg-none list-group">
                <v-client-table :data="userBuildList" :columns="tableColumns2" :options="tableOptions2">
                  <div slot="slot1"  slot-scope="props" class="list-group-item">
                    <h6 class="mb-1 text-wrap">{{ props.row.build_name }}</h6>
                    <div class="mb-1">{{ props.row.product.short_name }}</div>
                    <div class="d-flex w-100 justify-content-between align-items-center mb-1">
                      <small class="text-muted">{{ props.row.created_at | moment("M/DD/YYYY") }}</small>
                    </div>
                    <div class="d-flex w-100 justify-content-between align-items-center">
                      <small class="text-muted">{{ props.row.tot_price | currency }}</small>
                      <small class="text-muted">{{ props.row.options_count }} optionals</small>
                    </div>
                    
                    <hr>
                    <div class="text-center"><a href="#" class="" @click="viewBuild(props.row.id)"><i class="fa fa-search" aria-hidden="true"></i></a></div>
                  </div>
                </v-client-table>
              </div>

            </div>
          </slot>
          
        </div>
      </div> <!-- end build list col -->
      <div class="col-12 col-xl-4 order-1 order-xl-2">

        <div class="card border-0">
          <div class="card-header bg-transparent"><h3 class="text-muted">Create A Build</h3></div>

          <div class="card-body mb-2">
            <h5 class="card-title text-muted">Select a product to start your build.</h5>
            <div class="row d-flex align-items-center">
              <div class="col-12 col-xl-9">
                <v-select 
                  v-model="stan_config"
                  placeholder="Select a Product"
                  label="name"
                  :options= "allProdList"
                  :reduce="allProdList => allProdList.id"
                  class="p-0 bg-white style-chooser">
                </v-select>
              </div>
              <div class="col-12 col-xl-3 mt-2 mt-xl-0">
                <button v-if="stan_config != ''" @click="createBuildFromProd" class="btn btn-primary">Create</button>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body mb-2">
            <h5 class="card-title text-muted">OR</h5>
        </div>

        <div class="card-body mb-4">
            <h5 class="card-title text-muted">Select a previous build to edit.</h5>
            <div class="row d-flex align-items-center">
              <div class="col-12 col-xl-9">
                <v-select 
                  v-model="build_config"
                  placeholder="Select a Build"
                  label="build_name"
                  :options= "userBuildList"
                  :reduce="userBuildList => userBuildList.id"
                  class="p-0 bg-white style-chooser">
                </v-select>
              </div>
              <div class="col-12 col-xl-3 mt-2 mt-xl-0">
                <button v-if="build_config != ''" @click="createBuildFromBuild" class="btn btn-primary">Create</button>
              </div>
            </div>
          </div>
        </div>


        <hr class="d-block d-xl-none">
      </div> <!-- end build create col -->
    </div><!--  end intial row -->

  </div><!--  end container-fluid div -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../stores/product-builder-main-store.js'


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      stan_config: '',
      build_config: '',
      tableColumns: ['build_name', 'product.short_name', 'slot2', 'options_count', 'slot3', 'slot1'],
      tableOptions: {
        skin: 'table table-sm table-hover border-0 vuetable2',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 18,
        theme: 'bootstrap4',
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          build_name: '',
          'product.short_name': '',
          slot2: '',
          options_count: 'text-center', 
          created_at: '',
          slot1: 'text-center',
        }, 
        headings: { 
          build_name: 'Name',
          'product.short_name': 'Product',
          slot2: 'Price',
          options_count: 'Options', 
          slot3: 'Created',
          slot1: '',
        },
      },
      tableColumns2: ['slot1'],
      tableOptions2: {
        skin: 'table table-sm table-hover border-0 vuetable2',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 5,
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          slot1: '',
        }, 
        headings: { 
          slot1: '',
        },
      }
    }
  },
  computed: {
    userBuildList () { return this.$store.state.userBuildList },
    userBuildComp () { return this.$store.state.userBuildComp },
    allProdList () { return this.$store.state.allProdList },
    productComp () { return this.$store.state.productComp },
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },

    createBuildFromProd() {
      var _this = this;
      if(_this.stan_config == ''){
        return false;
      }
      var setup = [1, _this.stan_config];
      _this.getMainView('product-builder', '', '', setup);
    },

    createBuildFromBuild() {
      var _this = this;
      if(_this.build_config == ''){
        return false;
      }
      var setup = [2, _this.build_config];
      _this.getMainView('product-builder', '', '', setup);
    },

    viewBuild(x) {
      var _this = this;
      var setup = ['', x];
      _this.getMainView('product-view', '', '', setup);
    },
  },    
  components:{
    ScalingSquaresSpinner,
  },
  filters: {

  }
}
</script>
